module.exports = __webpack_public_path__ + "img/bm3.a1fd5182.png";